import { Directive } from '@angular/core';
import { NG_VALIDATORS, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[appEmailValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: EmailValidatorDirective,
    multi: true
  }]
})
export class EmailValidatorDirective {

  constructor() { }

  validate(control : AbstractControl){
    var email = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z_\-\.]+)\.([a-zA-Z]{2,5})$/; 
    // var email = ^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$;
    // var email = ^([1-zA-Z0-1@.\s]{1,255})$;
    if (control.value){
      if(!email.test(control.value)){
        // if(control.value != "" && !email){
          return {inv:true} 
        }
      else{
        // if(control.value.indexOf("@yahoo.com || @gmail.com")== -1){
        //   return {lengthError:true}
        // }
        return null;
        
      }
    }
  }

}
